export const resolveImgPath = (imagePath: string | undefined) => {
  if (imagePath) {
    if (imagePath?.startsWith("http")) {
      return imagePath;
    } else {
      return `${process.env.REACT_APP_BASE_URL?.split("/api")[0]}/${imagePath}`;
    }
  } else return undefined;
};
